<template>
  <div>
    <div class="md-autocomplete-loading" v-if="isRefreshing">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>
    <div v-show="config.showFilter">
      <md-table-toolbar class="_dynamic__toolbar">
        <md-field class="_uiKitInput">
          <label>{{config.label}}</label>
          <md-select 
            ref="dropdownRef" 
            class="_dynamic-select" 
            mdClass="_dynamic-option" 
            v-model="filterValue" 
            :disabled="isRefreshing" 
            @md-selected="onDynamicSelect" 
            @md-opened="openSelect" 
            @md-closed="openSelect">
            <md-option
              v-for="_option in config.columnFilterList"
              :key="_option.label"
              :value="_option.value"
            >{{ _option.value }}</md-option>
          </md-select>
        </md-field>
      </md-table-toolbar>
    </div>
    <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
      <span class="capitalized">{{ snackbarMsg }}</span>
    </md-snackbar>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries_custom from "@/graphql/queries_custom";
import * as mutations from "@/graphql/mutations";

export default {
  name: "crud-dynamic-select",
  components: {},
  props: {
    config: {
      type: Object,
      required: true,
    },
    formConfig: {
        type: Object,
        required: true
      },
  },
  data() {
    return {
      isRefreshing: false,
      filterValue: "",
      snackbarMsg: "",
      isSnackbarOpen: false,
    };
  },
  methods: {
    async getDynamicSelectList() {
      this.config.columnFilterList = [];
      let params = {},
        operation;
      operation = graphqlOperation(
        queries_custom[this.config.filterListQueryId],
        params
      );
      const result = await API.graphql(operation);
      if (result.data.listCaseStatusEnum) {
        result.data.listCaseStatusEnum.enumValues.forEach((item) => {
          let filterName = item.name.replace(/_/g, " ");
          let filterColumnItems = { label: item.name, value: filterName };
          this.config.columnFilterList.push(filterColumnItems);
        });
      }
    },
    async openSelect() {
      setImmediate( () => {
        this.$refs.dropdownRef.$refs.menu.$el.classList.add('_dynamic-options-select')
      })
    },
    async onDynamicSelect(value) {
      console.log(value);
      this.isRefreshing = true;
      let filterValue = this.config.columnFilterList.filter(element => element.value === value)
      if (filterValue.length > 0) {
        let updateValue = filterValue[0].label
        let error = null;
        await this.updateRecord(updateValue).catch((err) => (error = err));
        if (error) {
          return this.showNotification(null, error);
        }
        this.showNotification(`${[this.config.fieldToBeUpdate]} updated!`);
      }
    },
    async updateRecord(value) {
      let input = {
        id: this.$route.params.id,
        [this.config.fieldToBeUpdate]: value,
        [this.config.updatedById]: this.$reduce(this, "$Session.userId"),
      };
      console.log("Mutaiontion Input => ", input);
      const operation = graphqlOperation(
        mutations[this.config.updateMutationId],
        { input }
      );
      return API.graphql(operation);
    },
    /**
     * show notification messge
     * if error object provided found then show error notification
     * @param  {String} msg the notificaiton message
     * @param  {Object} error the error object
     * @return {void}
     */
    showNotification(msg, error) {
      console.log(msg);
      console.log(error);
      this.isRefreshing = false;

      if (msg) {
        this.snackbarMsg = msg;
        this.isSnackbarOpen = true;
        return;
      }
      this.filterValue = this.config.defaultSelectedValue;
      if (error && error.message) {
        this.snackbarMsg = error.message;
        this.isSnackbarOpen = true;
        return;
      }

      this.snackbarMsg = "Something went wrong - please try again!";
      this.isSnackbarOpen = true;
    },
  },
  mounted() {
    this.filterValue = this.config.defaultSelectedValue;
    this.getDynamicSelectList();
    console.log("this.$route.params.id => ", this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
.capitalized {
  text-transform: capitalize;
}
._uiKitInput {
  .md-menu.md-select {
    width: 184px;
  }
}
.md-toolbar-section-start {
  .md-toolbar.md-table-toolbar.md-transparent._dynamic__toolbar.md-theme-default.md-elevation-0 {
    padding: 9px 0px 0px 10px !important;
  }
}
/**/
</style>